// TEMPORARY DEBUG VERSION OF router/index.js
// Replace your router/index.js with this to see what's happening

import Vue from 'vue'
import VueRouter from 'vue-router'
import { auth, db } from '../firebase'
import { doc, getDoc } from 'firebase/firestore'
import HomeView from '../views/HomeView.vue'
import StaffDashboardView from '@/views/StaffDashboardView.vue'
import StaffOnboardCustomerView from '@/views/StaffOnboardCustomerView.vue'
import StaffManageSettingsView from '@/views/StaffManageSettingsView.vue'
import StaffPaymentsView from '@/views/StaffPaymentsView.vue'
import ManageAppProgressView from '@/views/ManageAppProgressView.vue'
import AdminProducts from '@/views/AdminProducts.vue'
import StaffProducts from '@/views/StaffProducts.vue'
import StaffProductDetail from '@/views/StaffProductDetail.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { redirectIfAuth: true }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/LoginView.vue'),
    meta: { redirectIfAuth: true }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/CustomerDashboardView.vue'),
    meta: { requiresAuth: true, role: 'Customer' }
  },
  {
    path: '/customer-settings',
    name: 'customer-settings',
    component: () => import('../views/CustomerSettingsView.vue'),
    meta: { requiresAuth: true, role: 'Customer' }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/AdminDashboardView.vue'),
    meta: { requiresAuth: true, role: 'Admin' }
  },
  {
    path: '/admin-settings',
    name: 'admin-settings',
    component: () => import('../views/AdminSettingsView.vue'),
    meta: { requiresAuth: true, role: 'Admin' }
  },
  {
    path: '/admin/templates',
    name: 'admin-templates',
    component: () => import('../views/AdminTemplates.vue'),
    meta: { requiresAuth: true, role: 'Admin' }
  },
  {
    path: '/manage-app-progress',
    name: 'ManageAppProgress',
    component: ManageAppProgressView,
    meta: { requiresAuth: true }
  },
  {
    path: '/staff-manage-settings',
    name: 'StaffManageSettings',
    component: StaffManageSettingsView,
    meta: { requiresAuth: true, role: 'Staff' }
  },
  {
    path: '/staff-dashboard',
    name: 'StaffDashboard',
    component: StaffDashboardView,
    meta: { requiresAuth: true, role: 'Staff' }
  },
  {
    path: '/staff-payments',
    name: 'StaffPayments',
    component: StaffPaymentsView,
    meta: { requiresAuth: true, role: 'Staff' }
  },
  {
    path: '/staff/templates',
    name: 'staff-templates',
    component: () => import('../views/StaffTemplates.vue'),
    meta: { requiresAuth: true, role: 'Staff' }
  },
  {
    path: '/staff-onboard-customer',
    name: 'StaffOnboardCustomer',
    component: StaffOnboardCustomerView,
    meta: { requiresAuth: true, role: 'Staff' }
  },
  {
    path: '/staff-leads',
    name: 'StaffLeads',
    component: () => import('../views/StaffLeads.vue'),
    meta: { requiresAuth: true, role: 'Staff' }
  },
  {
    path: '/services',
    name: 'services',
    component: () => import(/* webpackChunkName: "services" */ '../views/ServicesView.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "contact" */ '../views/ContactView.vue')
  },
  {
    path: '/admin/products',
    name: 'AdminProducts',
    component: AdminProducts,
    meta: { requiresAuth: true, role: 'Admin' }
  },
  {
    path: '/admin/products/:id',
    name: 'AdminProductDetail',
    component: StaffProductDetail,
    props: true,
    meta: { requiresAuth: true, role: 'Admin' }
  },
  {
    path: '/staff/products',
    name: 'StaffProducts',
    component: StaffProducts,
    meta: { requiresAuth: true, role: 'Staff' }
  },
  {
    path: '/staff/products/:id',
    name: 'StaffProductDetail',
    component: StaffProductDetail,
    props: true,
    meta: { requiresAuth: true, role: 'Staff' }
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Helper function to get user role from Firestore
async function getUserRole(uid) {
  console.log('🔍 getUserRole called with UID:', uid)
  try {
    const userDoc = await getDoc(doc(db, 'users', uid))
    console.log('🔍 User document exists?', userDoc.exists())
    
    if (userDoc.exists()) {
      const data = userDoc.data()
      console.log('🔍 User document data:', data)
      console.log('🔍 Role from document:', data.role)
      console.log('🔍 Role type:', typeof data.role)
      console.log('🔍 Role === "Admin"?', data.role === 'Admin')
      console.log('🔍 Role === "Staff"?', data.role === 'Staff')
      console.log('🔍 Role === "Customer"?', data.role === 'Customer')
      
      const role = data.role || 'Customer'
      console.log('🔍 Returning role:', role)
      return role
    }
    console.log('⚠️ User document does not exist, returning Customer')
    return 'Customer'
  } catch (error) {
    console.error('❌ Error getting user role:', error)
    return 'Customer'
  }
}

// Helper function to get redirect path based on role
function getRedirectPathForRole(role) {
  console.log('🎯 getRedirectPathForRole called with:', role)
  console.log('🎯 role === "Admin"?', role === 'Admin')
  console.log('🎯 role === "Staff"?', role === 'Staff')
  
  if (role === 'Admin') {
    console.log('✅ Returning /admin')
    return '/admin'
  }
  if (role === 'Staff') {
    console.log('✅ Returning /staff-dashboard')
    return '/staff-dashboard'
  }
  console.log('✅ Returning /dashboard (default)')
  return '/dashboard'
}

// Navigation guard
router.beforeEach(async (to, from, next) => {
  console.log('🚦 ROUTER GUARD TRIGGERED')
  console.log('🚦 Navigating from:', from.path)
  console.log('🚦 Navigating to:', to.path)
  console.log('🚦 Route meta:', to.meta)
  
  // Wait for auth to initialize
  await new Promise((resolve) => {
    const unsubscribe = auth.onAuthStateChanged(() => {
      unsubscribe()
      resolve()
    })
  })

  const currentUser = auth.currentUser
  console.log('🚦 Current user:', currentUser?.email || 'None')
  console.log('🚦 Current user UID:', currentUser?.uid || 'None')
  
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const redirectIfAuth = to.matched.some(record => record.meta.redirectIfAuth)
  
  console.log('🚦 Route requires auth?', requiresAuth)
  console.log('🚦 Route redirects if auth?', redirectIfAuth)

  // If route requires auth and user is not logged in
  if (requiresAuth && !currentUser) {
    console.log('🚦 ❌ Not logged in, redirecting to /login')
    next('/login')
    return
  }

  // If user is logged in and tries to access login/home page, redirect to their dashboard
  if (redirectIfAuth && currentUser) {
    console.log('🚦 User is logged in and accessing login/home, will redirect to dashboard')
    try {
      const role = await getUserRole(currentUser.uid)
      console.log('🚦 Got role:', role)
      const redirectPath = getRedirectPathForRole(role)
      console.log('🚦 Will redirect to:', redirectPath)
      next(redirectPath)
      return
    } catch (error) {
      console.error('🚦 ❌ Error in auth redirect:', error)
      next()
      return
    }
  }

  // Check role-based access
  if (requiresAuth && currentUser && to.meta.role) {
    console.log('🚦 Checking role-based access')
    console.log('🚦 Required role:', to.meta.role)
    try {
      const userRole = await getUserRole(currentUser.uid)
      console.log('🚦 User role:', userRole)
      console.log('🚦 Does role match?', to.meta.role === userRole)
      
      // Allow access if user role matches route role
      if (to.meta.role === userRole) {
        console.log('🚦 ✅ Role matches, allowing access')
        next()
        return
      }
      
      // If role doesn't match, redirect to their appropriate dashboard
      console.log('🚦 ❌ Role does not match, redirecting to appropriate dashboard')
      const redirectPath = getRedirectPathForRole(userRole)
      console.log('🚦 Redirecting to:', redirectPath)
      next(redirectPath)
      return
    } catch (error) {
      console.error('🚦 ❌ Error checking role:', error)
      next('/login')
      return
    }
  }

  console.log('🚦 ✅ No restrictions, allowing navigation')
  next()
})

export default router